<template>
  <div class="g-content site-list">
    <!-- 搜索 -->
    <div class="filter site-filter">
      <div class="site-filter-content">
        <a-form-model
          :model="form"
          :rules="rules"
          layout="inline"
          ref="formElement"
          style="display: flex;width:100%;justify-content: space-between;"
        >
          <div>
            <!-- 关键字 -->
            <a-form-model-item :label="null" prop="keyword">
              <a-input-search
                v-model="form.keyword"
                :placeholder="$t('com_form_keyword_input')"
                allowClear
                @search="onSearchSubmit"
                class="search-input"
              >
              </a-input-search>
            </a-form-model-item>
            <!-- 客户 -->
            <a-form-model-item
              :label="null"
              prop="customerId"
              v-if="customerList && customerList.length > 1"
            >
              <a-select
                :getPopupContainer="triggerNode => triggerNode.parentNode"
                v-model="form.customerId"
                :placeholder="$t('customer_form_all_customer')"
                show-search
                allowClear
                :filter-option="filterOption"
                @change="onSearchSubmit"
                :autosize="true"
                class="customer-select"
              >
                <a-select-option
                  :value="customer.customerId"
                  v-for="customer in customerList"
                  :key="customer.customerId"
                >
                  {{ customer.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <!-- 地区 -->
            <a-form-model-item :label="null" prop="areaId">
              <a-select
                :getPopupContainer="triggerNode => triggerNode.parentNode"
                v-model="form.areaId"
                :placeholder="$t('com_form_area_all')"
                show-search
                allowClear
                :filter-option="filterOption"
                @change="areaChange(onSearchSubmit)"
                :autosize="true"
                class="region-select"
              >
                <a-select-option :value="area.id" v-for="area in areaList" :key="area.id">
                  {{ area.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <!-- 国家 -->
            <a-form-model-item :label="null" prop="regionId" v-if="form.areaId">
              <a-select
                :getPopupContainer="triggerNode => triggerNode.parentNode"
                v-model="form.regionId"
                :placeholder="$t('com_form_region_all')"
                show-search
                allowClear
                :filter-option="filterOption"
                @change="onSearchSubmit"
                class="country-select"
              >
                <a-select-option
                  :value="country.id"
                  v-for="country in countryList"
                  :key="country.id"
                >
                  {{ country.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </div>
          <div>
            <!-- 提交 -->
            <a-form-model-item>
              <a-button type="primary" @click.prevent="onSearchSubmit" :loading="searchLoading">
                {{ $t('com_btn_search') }}
              </a-button>
            </a-form-model-item>

            <!-- 重置 -->
            <a-form-model-item style="margin-right: 0;">
              <a-button @click="onSearchReset">
                {{ $t('com_btn_reset') }}
              </a-button>
            </a-form-model-item>
          </div>
        </a-form-model>
      </div>
    </div>

    <!-- 列表 -->
    <div class="site-list-main">
      <!-- 操作 -->
      <div class="site-list-action">
        <!-- 添加站点 -->
        <router-link to="/manage/site/add" v-if="AUTH_SITE_ADD">
          <a-button type="primary" icon="plus">
            {{ $t('com_btn_add') }}
          </a-button>
        </router-link>
      </div>
      <!-- 列表 -->
      <div class="site-list-content">
        <!-- 加载中... -->
        <Loading :show="loading" v-if="loading" />

        <div v-else>
          <NetworkError v-if="list === null" />
          <div v-else>
            <a-table
              :columns="columns"
              :data-source="list"
              :pagination="false"
              :rowKey="(text, index) => index"
              bordered
              :loading="tableLoading"
              size="middle"
            >
              <!-- 名称 -->
              <template slot="Name" slot-scope="text, record">
                <router-link
                  :to="{
                    name: 'SiteDetail',
                    params: { id: record.info.stationId },
                  }"
                  v-if="AUTH_SITE_DETAIL"
                >
                  {{ text }}
                </router-link>
                <span v-else>
                  {{ text }}
                </span>
              </template>

              <!-- 地区/国家 -->
              <template slot="Area" slot-scope="text, record">
                <span v-if="text">
                  {{ areaListObject && areaListObject[text] ? areaListObject[text].name : '--' }}
                  <span v-if="record.info.regionId">
                    >
                    {{
                      areaListObject[record.info.regionId]
                        ? areaListObject[record.info.regionId].name
                        : '--'
                    }}
                  </span>
                </span>
                <span v-else>--</span>
              </template>

              <!-- 设备总数量 -->
              <template slot="deviceTotal" slot-scope="text, record">
                <router-link
                  :to="{
                    name: 'DeviceList',
                    query: {
                      type: 'all',
                      siteId: record.info.stationId,
                      customerId: record.info.customerId,
                    },
                  }"
                  v-if="AUTH_DEVICE && Number(text) > 0"
                >
                  {{ text || '0' }}
                </router-link>
                <span v-else>{{ text || '0' }} </span>
              </template>

              <!-- 离线设备数量 -->
              <template slot="DevicesOffline" slot-scope="text, record">
                <router-link
                  :to="{
                    name: 'DeviceList',
                    query: {
                      type: 'offline',
                      siteId: record.info.stationId,
                      customerId: record.info.customerId,
                    },
                  }"
                  v-if="
                    AUTH_DEVICE &&
                      Number(
                        listStatus && listStatus[record.info.stationId]
                          ? listStatus[record.info.stationId]['ofs']
                          : ''
                      ) > 0
                  "
                  style="color:#999;"
                >
                  {{
                    listStatus && listStatus[record.info.stationId]
                      ? listStatus[record.info.stationId]['ofs']
                      : ''
                  }}
                </router-link>
                <span v-else style="color:#999;">
                  {{
                    listStatus && listStatus[record.info.stationId]
                      ? listStatus[record.info.stationId]['ofs']
                      : ''
                  }}
                </span>
              </template>

              <!-- 告警状态 -->
              <template slot="deviceWarning" slot-scope="text, record">
                <div class="site-warning-wrapper" v-if="listStatus">
                  <router-link
                    :to="{
                      name: 'DeviceList',
                      query: {
                        type: 'faulted',
                        siteId: record.info.stationId,
                        customerId: record.info.customerId,
                      },
                    }"
                    v-if="AUTH_DEVICE"
                  >
                    <ListWarningContent :listStatus="listStatus" :record="record" />
                  </router-link>
                  <ListWarningContent :listStatus="listStatus" :record="record" v-else />
                </div>
              </template>

              <!-- 用户 -->
              <template slot="User" slot-scope="text">
                {{ text }}
              </template>

              <!-- 创建日期 -->
              <template slot="BuildDate" slot-scope="text">
                {{ text | formatDate('yyyy-MM-dd') }}
              </template>

              <!-- 时间 -->
              <template slot="CreateTime" slot-scope="text">
                {{ text | formatDate }}
              </template>

              <!-- 操作 -->
              <template slot="Action" slot-scope="text, record">
                <router-link
                  :to="{
                    name: 'SiteDetail',
                    params: { id: record.info.stationId },
                  }"
                  v-if="AUTH_SITE_DETAIL"
                >
                  <Icon type="eye" />
                </router-link>
              </template>
            </a-table>

            <div class="site-pagination" v-if="!searchLoading">
              <Pagination
                :current="pagination.current"
                :total="pagination.total"
                :pageSize.sync="pagination.pageSize"
                :callback="pageChange"
                @change="pageChange"
                show-quick-jumper
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as API from '@/api/site';
// mixins
import commonMixin from '@/mixins/common';
import cusomterMixin from '@/mixins/customer';
import areaMixin from '@/mixins/area';
import Config from '@/config';
import { trim, dragTableToScroll } from '@/libs/utils';
import ListWarningContent from './components/ListWarningContent.vue';
import siteAuth from '@/views/site/mixins/siteAuth';
import deviceAuth from '@/views/device/mixins/deviceAuth';
import { v4 as uuidv4 } from 'uuid';

export default {
  mixins: [commonMixin, cusomterMixin, areaMixin, siteAuth, deviceAuth],
  components: {
    ListWarningContent,
  },
  data() {
    return {
      Config,
      filters: this.$options.filters,
      list: null,
      listStatus: null,

      // 分页
      pagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 20,
        // 记录总条数
        total: 0,
      },

      loading: true,
      tableLoading: false,
      searchLoading: false,

      rules: {},
      // 搜索
      form: {
        customerId: undefined,
        areaId: undefined,
        regionId: undefined,

        status: 0,
        keyword: undefined,
      },

      // table columns
      columns: [
        {
          title: '#',
          align: 'center',
          customRender: (text, record, index) => {
            return (this.pagination.current - 1) * this.pagination.pageSize + (index + 1);
          },
        },

        {
          title: this.$t('site_table_name'),
          dataIndex: 'info.name',
          scopedSlots: { customRender: 'Name' },
        },

        {
          title: this.$t('site_table_devices_number'),
          align: 'center',
          dataIndex: 'deviceTotal',
          scopedSlots: { customRender: 'deviceTotal' },
        },

        {
          title: this.$t('site_table_divices_offline_number'),
          align: 'center',
          dataIndex: 'deviceOfflineTotal',
          scopedSlots: { customRender: 'DevicesOffline' },
        },

        {
          title: this.$t('com_form_area_region_label'),
          dataIndex: 'info.areaId',
          scopedSlots: { customRender: 'Area' },
        },

        {
          title: this.$t('com_table_user_created'),
          align: 'center',
          dataIndex: 'info.createUser',
          scopedSlots: { customRender: 'User' },
        },

        {
          title: this.$t('site_info_build_date'),
          align: 'center',
          dataIndex: 'info.buildDate',
          width: 120,
          scopedSlots: { customRender: 'BuildDate' },
        },

        {
          title: this.$t('com_table_created_time'),
          align: 'center',
          dataIndex: 'info.createTime',
          width: 'auto',
          scopedSlots: { customRender: 'CreateTime' },
        },
      ],
      horizontalScroll: null,
    };
  },

  created() {
    // customerId
    if (this.$route.query.customerId) {
      this.form.customerId = this.$route.query.customerId;
    }

    // areaId
    if (this.$route.query.areaId) {
      this.form.areaId = this.$route.query.areaId;
    }

    // regionId
    if (this.$route.query.regionId) {
      this.form.regionId = this.$route.query.regionId;
    }

    // status
    if (this.$route.query.status) {
      this.form.status = parseInt(this.$route.query.status, 10);
    }

    // keyword
    if (this.$route.query.keyword) {
      this.form.keyword = this.$route.query.keyword;
    }

    // pageNo
    if (this.$route.query.pageNo) {
      this.pagination.current = parseInt(this.$route.query.pageNo, 10);
    }

    // pageSize
    if (this.$route.query.pageSize) {
      this.pagination.pageSize = parseInt(this.$route.query.pageSize, 10);
    }

    this.getData();

    // 操作列
    if (this.AUTH_SITE_DETAIL) {
      this.columns.push({
        title: this.$t('com_table_action'),
        align: 'center',
        width: 'auto',
        scopedSlots: { customRender: 'Action' },
      });
    }
  },
  beforeDestroy() {
    this.horizontalScrollDestory();
  },
  methods: {
    // 搜索

    // 获取表单数据
    getData() {
      const _list = [this.getAllCustomerList(), this.getAreaList()];
      Promise.all(_list).finally(() => {
        // 更新area/region
        this.getCountryList(this.form.areaId);

        // 当只有一个customer时，默认选中这个customer
        if (this.customerList && this.customerList.length === 1) {
          this.form.customerId = this.customerList[0].customerId;
        }

        this.getList(true);

        // 全部接口返回时，清除loading
        this.$store.commit('setPageLoading', false);
      });
    },

    // get list
    getList(init) {
      const params = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.form,
      };

      // 去掉关键字两边的空格
      if (params.keyword) {
        params.keyword = trim(params.keyword);
        this.form.keyword = params.keyword;
      }

      this.pagination.current = params.pageNo;
      if (init) {
        this.loading = true;
      } else {
        this.tableLoading = true;
      }
      return API.SiteList(params)
        .then(res => {
          if (res.code === 0) {
            this.list = res.data || [];
            const ids = this.list.map(item => item.info.stationId);

            // 获取状态
            this.getStationStatus(ids);

            // 总数
            this.pagination.total = res.totalCount;
          }
        })
        .finally(() => {
          this.loading = false;
          this.tableLoading = false;
          this.searchLoading = false;

          // 表格横向滚动注册
          this.$nextTick(() => {
            this.horizontalScrollDestory();
            this.horizontalScroll = dragTableToScroll();
          });
        });
    },

    // 异步获取状态
    getStationStatus(ids) {
      if (!ids || (ids && ids.length === 0)) {
        return;
      }
      return API.SiteQueryStatus({ stationIds: ids.join(',') }).then(res => {
        if (res.code === 0) {
          this.listStatus = {};
          res.data.forEach(item => {
            this.listStatus[item.stationId] = item;
          });
        }
      });
    },

    // 横向滚动事件注销
    horizontalScrollDestory() {
      if (this.horizontalScroll) {
        this.horizontalScroll.destroy();
      }
    },

    // 分页
    pageChange(value) {
      this.pagination.current = value;
      // this.getList();
      this.reloadListPage();
    },

    // 重置表单
    onSearchReset() {
      this.$refs.formElement.resetFields();

      this.$router.replace({
        key: uuidv4(),
        name: 'SiteList',
      });
    },

    // 提交搜索
    onSearchSubmit() {
      // this.searchLoading = true;
      this.pagination.current = 1;
      // this.getList();

      this.reloadListPage();
    },

    // 禁用站点
    disabledStation(record) {
      const h = this.$createElement;
      this.$confirm({
        title: this.$t('site_confirm_diabled_title'),
        content: h('div', {}, [
          h('p', this.$t('site_confirm_content', { name: record.info.name })),
        ]),
        centered: true,
        onOk: () => {
          this.$store.commit('setFreeze', this.$t('com_ongoing_disable'));
          API.SiteDisable({ stationId: record.info.stationId })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_disabled_success'));

                // 重新获取详情
                this.getList();
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },

    // 启用站点
    enableStation(record) {
      const h = this.$createElement;
      this.$confirm({
        title: this.$t('site_confirm_enabled_title'),
        content: h('div', {}, [
          h('p', this.$t('site_confirm_content', { name: record.info.name })),
        ]),
        centered: true,
        onOk: () => {
          this.$store.commit('setFreeze', this.$t('com_ongoing_enable'));
          API.SiteEnable({ stationId: record.info.stationId })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_form_enabled_success'));

                // 重新获取详情
                this.getList();
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },

    // 重新跳转页面，在URL记录当前参数
    reloadListPage() {
      this.$router.push({
        key: uuidv4(),
        name: 'SiteList',
        query: {
          ...this.form,
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.site-list {
  // border-radius: 12px;
  overflow: hidden;
  background: @g-layout-background;
  display: flex;
  flex-direction: column;
  // 搜索
  .site-filter {
    // height: 84px;
    width: 100%;
    display: flex;
    background: @g-layout-background;
    margin-bottom: 16px;

    ::v-deep .site-filter-content {
      height: 100%;
      display: flex;
      padding: 2px 24px 0 24px;
      border-radius: 12px;
      background: #fff;
      align-items: center;
      justify-content: space-between;
      box-sizing: content-box;
      flex: 1;
      margin-bottom: 16px;

      /* 隐藏 a-input-search 组件的图标 */
      .ant-input-search-icon {
        display: none;
      }

      .customer-select {
        min-width: 180px;
      }

      .region-select {
        min-width: 240px;
      }

      .country-select {
        min-width: 180px;
      }

      .search-input {
        width: 300px;
      }
    }
  }

  // 内容
  .site-list-main {
    background: #fff;
    padding: 16px 24px 8px 24px;
    border-radius: 12px;
    // outline: @g-layout-background 12px solid;
    box-shadow: 0 -12px 0 0 @g-layout-background;
    display: flex;
    flex: 1;
    flex-direction: column;

    .site-list-action {
      margin-bottom: 24px;
    }

    .site-list-content {
      .site-warning-wrapper {
        display: flex;
        flex-wrap: wrap;
      }

      dl {
        ul {
          list-style: none;
          display: flex;
          border: #eee solid 1px;
          border-right: none;
          margin: 0;
          padding: 0;
          font-size: 12px;

          li {
            border-right: #eee solid 1px;
            flex: 1;
            padding: 10px 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;

            span {
              display: flex;
              align-items: center;

              i {
                display: block;
                width: 8px;
                height: 8px;
                border-radius: 100%;
                white-space: nowrap;
                margin-right: 5px;
              }

              em {
                font-style: normal;
              }

              .disabled {
                background: #999;
              }

              .enabled {
                background: #09f175;
              }
            }

            &:nth-child(2) {
              text-align: left;
              align-items: flex-start;
              max-width: 300px;
            }

            &:nth-child(3),
            &:nth-child(4) {
              max-width: 150px;
            }

            &:first-child {
              flex-direction: row;
              justify-content: flex-start;
              max-width: 400px;
            }
            &:last-child {
              flex-direction: row;
              justify-content: flex-start;
            }

            a {
              align-self: center;
              color: #666;
            }

            p {
              width: 100%;
              height: 25px;
              line-height: 25px;
              margin: 0;
            }
          }
        }

        dt {
          ul {
            border-bottom: none;

            li {
              font-weight: normal;
              height: 100%;
              background: #f9f9f9;
            }
          }
        }

        dd {
          ul {
            li {
              &:first-child {
                a {
                  display: flex;
                  word-break: break-all;
                  word-wrap: break-word;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  max-height: 150px;
                  flex-wrap: wrap;
                  align-items: center;

                  img {
                    max-height: 70px;
                    max-width: 100px;
                    margin-right: 15px;
                  }
                }
              }
              &:last-child {
                flex-direction: column;
                justify-content: center;
              }
            }
          }
        }
      }

      // 分页
      .site-pagination {
        justify-content: flex-end;
        display: flex;
        align-items: flex-end;
      }
    }
  }
}
</style>
